import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref, computed } from '@vue/composition-api'
//* Method to fill param request from table 'Usuarios'
export const configTableUsuarios = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const userRol = computed(() => store.state.cuenta.rolSelected) //* Return current role
  const nombres = Object
  if (userRol.value.id !== 3) {
    nombres.grupo = 'Tipo'
    nombres.roles = 'd-none '
    nombres.rol = ''
  } else {
    nombres.grupo = 'Grupo'
    nombres.roles = ''
    nombres.rol = 'rol'
  }
  const tableColumns = [
    {
      key: 'cuenta', label: 'Datos', sortable: true,
    },
    { key: 'grupo', label: nombres.grupo, sortable: true },
    {
      key: 'estado', label: 'Cuenta', sortable: true,
    },
    { key: 'matricula', label: 'Matricula', sortable: true },
    {
      key: nombres.rol, label: 'Roles', sortable: true, tdClass: nombres.roles,
    },
    { key: 'opciones' },
  ]

  // let actionws
  // if (userRol.value.id === 3) actionws = 1
  // else actionws = 13 // tipo - alumnos
  //* Params to fill table data & filters
  /*   const configRequest = ref({
    rolb: null, //* Filter
    grupob: null, //* Filter
    estadob: null, //* Filter
    wsParams: { action: actionws, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wsusuarios', //* WebService name
    filterGetter: 'usuario/filterUsuarios', //* Getter function to filter data
  }) */
  // *--------- UI --------*

  const resolveUserrolVariant = rol => {
    if (rol === 'Experto') return 'info'
    if (rol === 'Asesor') return 'success'
    if (rol === 'Docente') return 'warning'
    if (rol === 'Soporte') return 'danger'
    if (rol === 'Atención') return 'info'
    if (rol === 'Contacto') return 'info'
    return 'primary'
  }
  const resolveUserGrupoVariant = grupo => {
    if (grupo === 'Alumno') return 'primary'
    if (grupo === 'Servicios Escolares') return 'warning'
    if (grupo === 'ROOT') return 'danger'
    if (grupo === 'Asesor') return 'info'
    return 'primary'
  }

  const resolveUserrolIcon = rol => {
    if (rol === 'Experto') return 'CoffeeIcon'
    if (rol === 'Asesor') return 'BookIcon'
    if (rol === 'Docente') return 'BookOpenIcon'
    if (rol === 'Soporte') return 'ToolIcon'
    if (rol === 'Atención') return 'MessageSquareIcon'
    if (rol === 'Contacto') return 'MessageSquareIcon'
    if (rol === null) return 'SmileIcon'
    return 'UserIcon'
  }

  const resolveUserestadoVariant = estado => {
    if (estado === 'activo') return 'success'
    if (estado === 'no activo') return 'danger'
    if (estado === 'inactivo') return 'danger'
    return 'primary'
  }
  // eslint-disable-next-line no-unused-vars
  const resolveOnSearchDependencia = search => {

  }

  return {
    tableColumns,
    // configRequest,
    resolveUserrolVariant,
    resolveUserGrupoVariant,
    resolveUserrolIcon,
    resolveUserestadoVariant,
    resolveOnSearchDependencia,
  }
}

export const fetchUsuarios = idPlan => {
  const userRol = computed(() => store.state.cuenta.rolSelected) //* Return current role
  let actionws
  if (userRol.value.id === 3) actionws = 1
  else actionws = 13 // tipo - alumnos
  //* Params to fill table data & filters
  const configRequest = ref({
    rolb: null, //* Filter
    grupob: null, //* Filter
    estadob: null, //* Filter
    wsParams: { action: actionws, token: store.state.cuenta.session.token, idPlan }, //* Request params
    wsType: 'wsusuarios', //* WebService name
    filterGetter: 'usuario/filterUsuarios', //* Getter function to filter data
  })
  return { configRequest }
}

//* Load filter options with promises
export const useUsuariosCatalogos = () => {
  const statusOptions = [{ label: 'Activo', value: 'activo' },
    { label: 'Inactivo', value: 'no activo' }]
  const grupoOptions = ref([])
  const rolOptions = ref([])
  const gradoOptions = ref([])
  const estadoOptions = ref([])
  const puestoOptions = ref([])
  const departamentoOptions = ref([])

  const rolOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 6, token: store.state.cuenta.session.token }, 'wsusuarios')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          rolOptions.value = response.data.data
          resolve()
        } else reject(response.data.messag)
      })
      .catch(err => { reject(err) })
  })

  const grupoOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 7, token: store.state.cuenta.session.token }, 'wsusuarios')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          grupoOptions.value = response.data.data
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  const gradoOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 11 })
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          gradoOptions.value = response.data.data
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  const puestoOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 10 })
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          puestoOptions.value = response.data.data
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  const departamentoOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 9 })
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          departamentoOptions.value = response.data.data
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  const estadoOptionsPromise = new Promise((resolve, reject) => {
    getData({ action: 2 })
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          estadoOptions.value = response.data.data
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  return {
    // Promise fetch options
    estadoOptionsPromise,
    rolOptionsPromise,
    grupoOptionsPromise,
    gradoOptionsPromise,
    puestoOptionsPromise,
    departamentoOptionsPromise,
    // Options
    rolOptions,
    grupoOptions,
    statusOptions,
    gradoOptions,
    estadoOptions,
    puestoOptions,
    departamentoOptions,

  }
}
